import React from 'react';

export const ValuesSection = () => {
  const values = [
    {
      icon: '🔍',
      title: 'AI Maturity Model for HR',
      description: 'Six dimensions. Five levels. The diagnostic that tells you where you actually stand — not where vendors say you stand.'
    },
    {
      icon: '📊',
      title: 'Three Compasses',
      description: 'Performance, Cost, and Human. Prove value in the CFO\'s language. Manage economics before scale breaks the budget.'
    },
    {
      icon: '🛡️',
      title: 'ARISE Framework',
      description: 'When AI fails — and it will — respond with transparency. Five stages from crisis to credibility.'
    },
    {
      icon: '📋',
      title: '84 KRAs',
      description: 'Key Result Areas covering every HR domain. Each with measurable OKRs and trackable KPIs.'
    },
    {
      icon: '📐',
      title: '5 Boardroom Cheat Sheets',
      description: 'One-page framework summaries designed to be photographed before your next Board meeting.'
    },
    {
      icon: '🌐',
      title: 'Platform Priority Access',
      description: 'AIFirstCHRO.com brings the frameworks to life. First 75 readers get beta access when it launches.'
    }
  ];

  return (
    <section className="section-wrap-white">
      <div className="section-inner">
        <div className="section-label">What you receive</div>
        <div className="section-title">Not just a book. A system.</div>
        <div className="section-sub">Every copy is signed by the author with a personal note. Here is what waits inside.</div>
        <div className="value-grid">
          {values.map((value, idx) => (
            <div key={idx} className="value-card">
              <div className="value-card-icon">{value.icon}</div>
              <h4>{value.title}</h4>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
